import React from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../components/Navbar/Navbar";
import BlogList from "../components/BlogList/BlogList";
import Footer from "../components/Footer/Footer";

const Blog = () => {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Music Blog by Mukesh Rathore | Composition, Production & Indie Music</title>

        <meta
          name="description"
          content="Explore music composition, production, and indie music career insights by Mukesh Rathore—independent music composer and educator with 28+ years of experience."
        />

        <meta
          property="og:title"
          content="Music Blog by Mukesh Rathore | Singing, Composition, Production & Indie Music"
        />

        <meta
          property="og:description"
          content="Articles and insights on music composition, production, and building an independent music career, written by composer and educator Mukesh Rathore."
        />
        <link rel="canonical" href="https://mukeshrathore.com/blog" />
      </Helmet>

      <Navbar />
      <section className="py-16 px-6 bg-gradient-to-r from-purple-900 to-indigo-900 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl font-bold mb-6">Blog & Resources</h1>
          <p className="text-xl text-gray-200">
            Insights, strategies, and practical tips to help you build your online empire
          </p>
        </div>
      </section>
      <BlogList />
      <Footer />
    </div>
  );
};

export default Blog;
